/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, group: NonNullable<unknown> }} Assistant_Activity_CreatedInputs */



/**
* | output |
* | --- |
* | "Created {count} events in {group}" |
*
* @param {Assistant_Activity_CreatedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_activity_created = /** @type {((inputs: Assistant_Activity_CreatedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Activity_CreatedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Création d'événements ${i?.count} dans ${i?.group}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count}-Ereignisse in ${i?.group} erstellt`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Creati gli eventi ${i?.count} in ${i?.group}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Созданы события ${i?.count} в ${i?.group}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Se crearon eventos ${i?.count} en ${i?.group}.`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`在 ${i?.group} 中创建了 ${i?.count} 事件`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.group}で${i?.count}イベントを作成しました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.group} में ${i?.count} इवेंट बनाए गए`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Criados eventos ${i?.count} em ${i?.group}`)
	return /** @type {LocalizedString} */ (`Created ${i?.count} events in ${i?.group}`)
});